export default "__VITE_ASSET__C_Jj$J_4__"